import { useState, useEffect } from "react";
import RttService from "../support/rtt-service.json";

interface UIConfig {
  uiFundListUrl: string;
  uiFormSubmitUrl: string;
  uiFormSubmitCompleteUrl: string;
  errorSubmissionUrl: string;
  debug: boolean;
}

export const hostname = {
  get: () => window.location.hostname
};

export function useConfig() {
  const [config, setConfig] = useState<UIConfig | null>(null);
  const _hostname = hostname.get();

  useEffect(() => {
    let urls = RttService.development;
    if (_hostname.indexOf("develop") !== -1) urls = RttService.development;
    else if (_hostname.indexOf("release") !== -1) urls = RttService.release;
    else if (_hostname.indexOf("test") !== -1) urls = RttService.release;
    else if (_hostname.indexOf("www.americancentury.com") !== -1)
      urls = RttService.production;
    setConfig(urls);
  }, [_hostname]);

  return config;
}
